var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlbum = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.5 2.25H6.75a3 3 0 0 0-3 3V21a.75.75 0 0 0 .75.75H18a.75.75 0 1 0 0-1.5H5.25a1.5 1.5 0 0 1 1.5-1.5H19.5a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75m-.75 15h-12c-.527 0-1.044.138-1.5.402V5.25a1.5 1.5 0 0 1 1.5-1.5h12z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.926 11.891 19 13.985v1.819L16.027 12.8l-1.59 1.607L17.3 17.3h-1.8l-6.364-6.429L5 15.05v-1.818l3.236-3.27a1.266 1.266 0 0 1 1.8 0l3.5 3.536 1.59-1.607a1.27 1.27 0 0 1 .9-.377 1.26 1.26 0 0 1 .9.377m-3.492-3.162a.97.97 0 0 0 .118 1.217.95.95 0 0 0 1.557-.313.97.97 0 0 0-.207-1.05.95.95 0 0 0-1.04-.21.96.96 0 0 0-.428.356"
})));
export default SvgAlbum;